import React from 'react';
import {
    Box, Text, Flex, Link
} from 'components/ui';
import Radio from 'components/Inputs/Radio/Radio';
import Address from 'components/Addresses/Address';
import { forms } from 'style/config';
import TaxClaimUtils from 'utils/TaxClaim';
import { wrapFunctionalComponent } from 'utils/framework';
import AccordionButton from 'components/FrictionlessCheckout/LayoutCard/AccordionButton';

function ShipAddressListItem({
    address,
    isNCR,
    currentShipAddressId,
    showTaxExemptAddress,
    taxExemptAddressLabel,
    removeAddressLabel,
    removeLabel,
    editAddressLabel,
    editLabel,
    onSelect,
    onRemove,
    onEdit,
    saveAndContinueDebounce,
    buttonText,
    hal,
    isRadio = true,
    fedexPickupLabel,
    labelName,
    shouldDisplayButtons = false
}) {
    if (!address) {
        return null;
    }

    const taxExempt = showTaxExemptAddress && TaxClaimUtils.isTaxExemptAddress(address);

    const isSelected = currentShipAddressId === address.addressId;

    return (
        <Flex
            justifyContent='space-between'
            data-at={Sephora.debug.dataAt('shipping_address_display')}
            alignItems='flex-start'
        >
            <Box>
                {isRadio ? (
                    <Radio
                        name={labelName}
                        checked={isSelected}
                        onClick={onSelect}
                        alignItems='flex-start'
                        paddingY={0}
                        maxWidth='100%'
                    >
                        {hal && (
                            <Text
                                fontSize='sm'
                                is='p'
                                marginBottom={1}
                            >
                                {fedexPickupLabel}
                            </Text>
                        )}
                        <Address
                            address={address}
                            isEditShippingOnCheckout
                            isHalAddress={hal}
                            isFrictionLessCheckout
                            {...(!shouldDisplayButtons && { shouldHideDefault: !buttonText })}
                            marginBottom={0}
                        />
                        {taxExempt && (
                            <Box
                                display='inline-flex'
                                backgroundColor='black'
                                borderRadius={2}
                                paddingX={2}
                                marginTop={4}
                                alignContent='center'
                                width='auto'
                            >
                                <Text
                                    color='white'
                                    fontWeight={700}
                                    fontSize='xs'
                                    display='inline-block'
                                >
                                    {taxExemptAddressLabel}
                                </Text>
                            </Box>
                        )}
                    </Radio>
                ) : (
                    <Address
                        address={address}
                        isEditShippingOnCheckout
                        notMargin={!isRadio}
                        isHalAddress={hal}
                        isFrictionLessCheckout
                        {...(!shouldDisplayButtons && { shouldHideDefault: !buttonText })}
                    />
                )}

                {!isNCR && isSelected && buttonText && (
                    <AccordionButton
                        marginLeft={6}
                        marginTop={3}
                        width={['auto', '18.5rem']}
                        onClick={saveAndContinueDebounce}
                        btnText={buttonText}
                    />
                )}
            </Box>

            {((!taxExempt && buttonText) || shouldDisplayButtons) && (
                <Flex
                    marginBottom={isNCR && 4}
                    marginLeft={forms.RADIO_SIZE + forms.RADIO_MARGIN + 'px'}
                    flex='none'
                    alignItems='flex-start'
                    css={{ transform: 'translateY(-1px)' }}
                >
                    {!isNCR && !hal && (
                        <>
                            <Link
                                aria-label={removeAddressLabel}
                                paddingX={2}
                                marginX={-2}
                                color='blue'
                                onClick={onRemove}
                                data-at={Sephora.debug.dataAt('remove_address_btn')}
                            >
                                {removeLabel}
                            </Link>
                            <Box
                                borderLeft={1}
                                marginX={3}
                                borderColor='divider'
                                alignSelf='stretch'
                            />
                        </>
                    )}
                    <Link
                        aria-label={editAddressLabel}
                        aria-controls='ship_address_form'
                        paddingX={2}
                        marginX={-2}
                        color='blue'
                        onClick={onEdit}
                    >
                        {editLabel}
                    </Link>
                </Flex>
            )}
        </Flex>
    );
}

export default wrapFunctionalComponent(ShipAddressListItem, 'ShipAddressListItem');
